import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const WarningIcon = styled(FontAwesomeIcon)`
  color: var(--red);
  font-size: 30px;
`
export const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
